import Template from "../templates/CreateHealthcareProviderExcerpt/CreateHealthcareProviderExcerpt";

const CreateHealthcareProviderExcerpt = () => <Template />;

export default CreateHealthcareProviderExcerpt;
